module.exports = __webpack_public_path__ + "static/media/male-yellow-small.270c6e8e.png";